import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Get from '../../../api/internal/Get';
import DateOnlyFormatter from '../../../helpers/inputs/DateOnlyFormatter';
import Header from '../../../layouts/Header';
import { MdDownload } from 'react-icons/md';
import BBITable from '../../../helpers/bBITable/BBITable';
import FilterData from '../../../helpers/filter/FilterData';
import View from '../../../helpers/slab/View';
import ViewLoad from '../../../features/views/load/Load';
import ViewRental from '../../../features/views/rental/Rental';
import ViewPayable from '../../../features/views/payable/Payable';
import ViewVendor from '../../../features/views/vendor/Vendor';
import PostBody from '../../../api/internal/PostBody';

const BillPayablesBoard = () => {
  const [payableBoard, setPayableBoard] = useState<Array<PayableBoard>>([]);
  const filterValue = useOutletContext();

  useEffect(() => {
    GetPayables();
  }, []);

  function GetPayables() {
    Get(`/Accounting/GetLoadlessPayableBoard/`).then(response => {
      if (response) {
        setPayableBoard(response.data);
      }
    });
  }

  function FormatPayableBoard(board) {
    return board.map(payable => ({
      ...payable,
       attribute: payable.loadId
        ? payable.loadId
        : payable.rentalId && 'Rental: ' + payable.rentalId,
      dueDate: DateOnlyFormatter(payable.dueDate),
      billDate: DateOnlyFormatter(payable.billDate),
      total: payable.total.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
      openBalance: payable.openBalance.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
    }));
  }

  function DownloadPayableReportCSV(payables) {
    let payableIdsToDownload = [];
    payableIdsToDownload = payables?.map(x => x.vendorAssignmentId);
    if (payableIdsToDownload.length > 0) {
      const payload = { PayablesIdList: [...payableIdsToDownload] };
      PostBody('Accounting/DownloadLoadlessPayableReportCSV', payload).then(
        response => {
          if (response) {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download =
              new Date().toISOString().split('T')[0].replace(/[-]/g, '') +
              '_Payables Report.csv';
            a.click();
            URL.revokeObjectURL(url);
          }
        },
      );
    }
  }

  const tableData = FilterData(FormatPayableBoard(payableBoard), filterValue);

  const columnConfig = [
    {
      key: '1',
      attribute: 'billName',
      attributeprimaryhidden: 'vendorAssignmentId',
      header: 'Bill Name',
      onClick: e =>
        View(
          e.target.dataset.attributeprimaryhidden && (
            <ViewPayable
              vendorAssignmentId={e.target.dataset.attributeprimaryhidden}
              loadId={e.target.dataset.attributesecondaryhidden}
              rentalId={e.target.dataset.attributetertiaryhidden}
              billName={e.target.innerText}
            />
          ),
        ),
      dataType: 'number',
    },
    {
      key: '2',
      attribute: 'attribute',
      attributeprimaryhidden: 'loadId',
      attributesecondaryhidden: 'rentalId',
      header: 'Load #',
      onClick: e =>
        View(
          e.target.dataset.attributeprimaryhidden ? (
            <ViewLoad loadId={e.target.dataset.attributeprimaryhidden} />
          ) : (
            e.target.dataset.attributesecondaryhidden && (
              <ViewRental
                rentalId={e.target.dataset.attributesecondaryhidden}
              />
            )
          ),
        ),
      dataType: 'number',
    },
    {
      key: '3',
      attribute: 'vendorName',
      attributeprimaryhidden: 'vendorId',
      header: 'Vendor',
      onClick: e =>
        View(
          <ViewVendor
            vendorName={e.target.innerText}
            vendorId={e.target.dataset.attributeprimaryhidden}
          />,
        ),
    },
    {
      key: '4',
      attribute: 'assetName',
      attributeprimaryhidden: 'assetId',
      header: 'Asset',
      dataType: 'string',
    },
    {
      key: '5',
      attribute: 'billQuickBooksId',
      header: 'Bill QuickBooks ID',
    },
    {
      key: '6',
      attribute: 'billDate',
      header: 'Bill Date',
      dataType: 'date',
    },
    {
      key: '7',
      attribute: 'dueDate',
      header: 'Due Date',
      dataType: 'date',
    },
    {
      key: '8',
      attribute: 'note',
      header: 'Note',
    },
    {
      key: '9',
      attribute: 'chartOfAccountName',
      header: 'Account',
      dataType: 'string',
    },
    {
      key: '10',
      attribute: 'rate',
      header: 'Rate',
    },
    {
      key: '11',
      attribute: 'quantity',
      header: 'Quantity',
    },
    {
      key: '12',
      attribute: 'total',
      header: 'Total',
      dataType: 'currency',
    },
        {
      key: '13',
      attribute: 'openBalance',
      header: 'Open Balance',
      dataType: 'string',
    },
  ];

  return (
    <>
      <Header>
        <div>
          <button onClick={() => DownloadPayableReportCSV(tableData)}>
            <MdDownload />
            <span>Download</span>
          </button>
        </div>
      </Header>
      <BBITable data={tableData} columns={columnConfig} />
    </>
  );
};

export default BillPayablesBoard;
